"use client";

import { useCallback } from "react";
import { changeAccountLocale, getLocale, type Locale } from "@tami/core/intl";

import { unwrapActionResult } from "@/lib/action-result";
import { chooseLocale } from "@/lib/i18n/client-locale";
import { useInternalAuth } from "@/providers/auth-provider";
import { updateMyLocale } from "@/services/user/update-my-locale.service";

/**
 * Seletor de idioma das páginas públicas (home). Visitante só troca o cookie
 * e recarrega; quem está logado grava na conta primeiro — senão o próximo
 * login (`useAccountLocaleSync`) traria de volta o idioma antigo. Uma escolha
 * só para tela, e-mail e assistente.
 */
export function useSiteLocale() {
  const { user } = useInternalAuth();
  const locale = getLocale();

  const change = useCallback(
    async (next: Locale) => {
      if (!user) {
        chooseLocale(next);
        return;
      }
      await changeAccountLocale(
        next,
        locale,
        (value) => unwrapActionResult(updateMyLocale(value)),
        chooseLocale,
      );
    },
    [user, locale],
  );

  return { locale, change } as const;
}
